// @ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import { styled, Switch, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useOutletContext } from "react-router-dom";
import Loading from "../../components/Loading";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { LiveIcon, CashIcon, NoBuyerIcon } from "../../components/Live";
import HotelIcon from "@mui/icons-material/LocalHotelOutlined";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import BathtubOutlinedIcon from "@mui/icons-material/BathtubOutlined";
import { getFavorityProperty } from "../../redux/slice/favoritePropertySlice";
import { PropertyCard } from "./PropertyCard";
import { Helmet } from "react-helmet";
import CommonHeading from "../../components/commonComponents/commonHeading";
import { BackButton } from "../../components/commonComponents/BackButton";
export default function Favorties() {
  const scrollContainerRef = useRef(null);
  const [isRemoteBiddingEnable, setIsRemoteBiddingEnable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [countdowns, setCountdowns] = useState([]);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const isMobile = useOutletContext();
  const dispatch = useDispatch();
  const countdownInterval = useRef(null);
  const { loginInvestorId } = useSelector((state) => state?.user);
  const { favoriteProperties, isAdding } = useSelector(
    (state) => state.favoriteProperties
  );

  const { properties } = useSelector((state) => state.properties);
  const TSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      inputProps={{ 'aria-label': 'avaliable-properties' }}
      {...props}
    />
  ))(({ theme }) => ({
    width: 38,
    height: 20.8,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            isRemoteBiddingEnable === true ? "#ff5c397a" : "transparent",
          opacity: 1,
          border: "1px solid",
          borderColor: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "& + .MuiSwitch-track": {
        backgroundColor:
          isRemoteBiddingEnable === true ? "#ff5c397a" : "transparent",
        opacity: 1,
        border: "1px solid",
        borderColor: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#FF5C39",
        border:
          isRemoteBiddingEnable === true
            ? "6px solid #FF5C39"
            : "6px solid #9FA4AB",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "&.MuiSwitch-track": {
      backgroundColor:
        isRemoteBiddingEnable === true ? "#ff5c397a" : "transparent",
      opacity: 1,
      border: "1.5px solid",
      borderColor: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
    },
    "& .MuiSwitch-thumb": {
      marginLeft: 0.5,
      width: 16,
      height: 16,
      color: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));

  const handlegetFavoriteProperties = async () => {
    try {
      await dispatch(getFavorityProperty(loginInvestorId));
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    if (!properties) {
      return;
    }
    handlegetFavoriteProperties();
  }, [properties]);


   useEffect(() => {
      if (!favoriteProperties || favoriteProperties.length === 0) {
        return;
      }
      // Function to update the countdown for each property
      const updateCountdowns = () => {
        const newCountdowns = favoriteProperties?.map((property, index) => {
          const auctionStartStr = moment
            .parseZone(property?.srpSaleDateTime)
            .format("YYYY-MM-DDTHH:mm:ssZ");
      
          const auctionStartDate = new Date(auctionStartStr);
          const currentDate = new Date();
          const timeDifferenceMilliseconds = auctionStartDate - currentDate; // Time difference in milliseconds
      
          // If the auction has already started or is in the past
          if (timeDifferenceMilliseconds <= 0) {
            return {
              index,
              timeRemaining: 0, // Time has passed, so 0 milliseconds
            };
          }
      
          return {
            index,
            timeRemaining: timeDifferenceMilliseconds, // Time difference in milliseconds
          };
        });
      
        setCountdowns((prevCountdowns) => {
          // Ensure `prevCountdowns` is an array and clone it
          const updatedCountdowns = [...prevCountdowns];
          
          // Update the countdown for each property using the index
          newCountdowns?.forEach(({ index, timeRemaining }) => {
            updatedCountdowns[index] = { timeRemaining };
          });
      
          return updatedCountdowns;
        });
      };
      
  
      // Set an interval to update the countdown every second
      countdownInterval.current = setInterval(updateCountdowns, 1000);
  
      // Call updateCountdowns immediately to show the time remaining without waiting for the first interval
      updateCountdowns();
  
      // Cleanup function to clear the interval when the component is unmounted
      return () => clearInterval(countdownInterval.current);
    }, [properties]);

  const handleIsremoteBiddingEnable = () => {
    setIsRemoteBiddingEnable((prevState) => !prevState);
  };

  const filterAuctionsWithDaysRemaining = () => {
    const upcomingAuctions = favoriteProperties?.filter((propertyItems) => {
      const startDate = moment.parseZone(`${propertyItems.srpSaleDateTime}`);
      const currentDate = moment();

      const daysRemaining = startDate.diff(currentDate, "days");

      if (daysRemaining > 0) {
        return true;
      }
      return false;
    });
  };

  const toggleFilteredAuctionList = () => {
    if (isOpen) {
      // If the list is open, clear the filtered auctions
      setFilteredAuctions([]);
    }
    // Toggle the open state
    setIsOpen(!isOpen);
  };

  function formatToDollar(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0, // No decimal places
      maximumFractionDigits: 0,
    }).format(amount);
  }

  return (
    <>
    <div className='flex justify-start items-center'>
    </div>
      <Helmet>
        <title>{`xBid | Favorites`}</title>
        <meta
          name="description"
          content={`Your favorites properties listed here`}
        />
      </Helmet>
      <CommonHeading sx={{ mb: 2, fontWeight: "600", fontSize: 22,mt:{sm:"20px",md:"0px",xs:"2px"} }} heading={"Favorites"} />

      <div className="bg-[#fff] p-2 w-full">
        <Grid
          size={"auto"}
          ml={"auto"}
          textAlign={"right"}
          color={isRemoteBiddingEnable ? "#FF5C39" : "#3B3B3B"}
          sx={{ fontSize: "14px", fontWeight: 400, lineHeight: "27px" }}
        >
          Only show properties available for remote bidding
          <TSwitch
            checked={isRemoteBiddingEnable}
            onChange={handleIsremoteBiddingEnable}
            sx={{ m: 1 }}
          />
        </Grid>
      </div>

      <div ref={scrollContainerRef} className="bg-white p-4 mt-3">
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="flex justify-between mb-4">
              <h2 className="text-lg font-semibold ml-2" role="heading">
                Showing {favoriteProperties?.length} Auction Properties
              </h2>
              {!isMobile && (
                <div className="flex items-center gap-1">
                  <p className="text-base font-semibold">Sort By: </p>
                  <span className="font-normal">Auction Starting Soon</span>
                  {isOpen ? (
                    <GoChevronUp
                      onClick={toggleFilteredAuctionList}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <GoChevronDown
                      style={{ cursor: "pointer" }}
                      onClick={filterAuctionsWithDaysRemaining}
                    />
                  )}
                </div>
              )}
            </div>

            {/* Render Auctions (filtered or all properties) */}
            <div>
              {(isOpen && filteredAuctions.length > 0
                ? filteredAuctions
                : favoriteProperties
              ).map((item, index) => (
                <PropertyCard
                  key={index}
                  item={item}
                  isMobile={isMobile}
                  loading={loading}
                  countdowns={countdowns[index]}
                  formatToDollar={formatToDollar}
                  index={index}
                />
              ))}

              {isDataAvailable && fetchLoading && (
                <div className="w-full h-[10vh] flex items-center justify-center">
                  <CircularProgress sx={{ color: "#faaf19" }} />
                </div>
              )}

              {isDataAvailable && (
                <p className="text-center py-2 text-lg font-medium">
                  {favoriteProperties.length > 0
                    ? "No more properties available..."
                    : "No properties available"}
                </p>
              )}
            </div>

            <div className="flex justify-center items-center">
              {loading && (
                <p className="text-lg font-medium text-[#FF5C39]">Loading...</p>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}
